jQuery(function($){
  //Brand Goto
  if($('body').hasClass('page-vendorlist')){
    $(".goto-brand").on('click', function() {
      var brand_id = $(this).attr('data-href');
      $('html, body').animate({
          'scrollTop' : $(brand_id).offset().top - $('.menu').height()- 100
      });
	});
  }
});